import React, { useEffect } from 'react';
import AssetStep from './AssetStep';
import Asset1 from '../../assets/Workwithus/Asset1.jpg';
import Asset2 from '../../assets/Workwithus/Asset2.jpg';
import Asset3 from '../../assets/Workwithus/Asset3.jpg';
import Asset4 from '../../assets/Workwithus/Asset4.jpg';
import '../../styles/WorkWithUs.css';
const steps = [
    {
      image: Asset1,
      title: (
        <>
          1. Building the Foundation
          <br />
          (21–30)
        </>
      ),
      description: 'Start by purchasing your first property, typically a HDB flat, EC, or small condo. Secure something within your means.',
      goal: 'Build a good credit score and savings to prepare for future investments.',
    },
    {
      image: Asset2,
      title: (
        <>
          2. Growing Your Portfolio
          <br />
          (30–40)
        </>
      ),
      description: 'Once stable, upgrade to a larger home such as a private condo or landed property using built-up equity.',
      goal: 'Sell or rent your first property, use the proceeds to invest in your second, and start building long-term wealth.',
    },
    {
      image: Asset3,
      title: (
        <>
          3. Maximizing Your Assets
          <br />
          (40–54)
        </>
      ),
      description: 'Purchase your 2nd or 3rd property in a high-demand area. Focus on capital growth and rental yield.',
      goal: 'Build a solid property portfolio, possibly including commercial properties or overseas assets.',
    },
    {
      image: Asset4,
      title: (
        <>
          4. Transition to Purposeful Living
          <br />
          (55+)
        </>
      ),
      description: 'Downsize, pay off mortgages, or reallocate assets. Focus on a balanced lifestyle with passive income.',
      goal: 'Preserve wealth, generate stable income, and plan for retirement and legacy/succession.',
    },
  ];
  

const AssetProgressionSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, { threshold: 0.1 });

    const elements = document.querySelectorAll('.fade-in');
    elements.forEach(el => observer.observe(el));

    return () => elements.forEach(el => observer.unobserve(el));
  }, []);

  return (
    <section className='innerSection'>
      <h2>Your Asset Progression Journey</h2>
      <div className="assetGrid">
        {steps.map((step, index) => (
          <AssetStep
            key={index}
            image={step.image}
            title={step.title}
            description={step.description}
            goal={step.goal}
            index={index}
          />
        ))}
      </div>


    </section>
  );
};

export default AssetProgressionSection;
